<template>
  <div class="head">
    <div class="main">
      <Logo class="tlogo" />
      <div class="rpart">
        <div class="menu">
          <ul>
            <li v-for="(nav,index) in menu" :key="index" @click="jump(nav.url, nav.target)">
              <a :class="$route.meta == nav.tit ?'a-cur':''">{{ $t('menu.' + nav.tit) }}</a>
            </li>
          </ul>
        </div>
        <!-- <span class="lang">
          <i class="iconfont white-color" style="font-size:16px;padding:0 5px;">|</i>
          <Dropdown trigger="click" placement="bottom-end" class="langlist" @on-click="handleLang">
            <a href="javascript:void(0)">
              {{$t('language')}}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <template v-for="(item,index) in langList">
                <DropdownItem :name="item.val" :key="index">{{item.tit}}</DropdownItem>
              </template>
            </DropdownMenu>
          </Dropdown>
        </span> -->
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "./Logo";
import { Dropdown, DropdownMenu, DropdownItem, Icon } from "iview";
import { list } from "../lang";

export default {
  inject: ["reload"],
  name: "Head",
  components: {
    Logo,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Icon
  },
  data() {
    return {
      menu: [
        {
          tit: "home",
          url: "/",
          target: "self"
        },
        {
          tit: "service",
          url: "/service",
          target: "self"
        },
        {
          tit: "cochain",
          url: "/cochain",
          target: "self"
        },

        {
          tit: "developer",
          url: "/developer",
          target: "self"
        },
        {
          tit: "team",
          url: "/team",
          target: "self"
        },
        {
          tit: "message",
          url: "/message",
          target: "self"
        },
        {
          tit: "wallet",
          url: "/wallet",
          target: "self"
        },
        {
          tit: "browser",
          url: "https://holographic.sdchain.io/",
          target: "blank"
        }
      ],
    
    };
  },
  methods: {
    jump(url, target) {
      if (target == "self") {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    // handleLang(val) {
    //   localStorage.Lang = val;
    //   this.$i18n.locale = val;
    //   this.reload();
    // }
  }
};
</script>

<style scoped lang="less">
@import url("../assets/css/var.less");
.head {
  min-width: @min-width;
  max-width: @max-width;
  position: absolute;
  width: 100%;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0%);
  z-index: 1;
  .tlogo {
    display: inline-block;
    line-height: 130px;
    height: 130px;
  }
  .rpart {
    display: inline-block;
    text-align: center;
    
  }
  .menu {
    display: inline-block;
    vertical-align: middle;
    text-align: right;
    font-size: 15px;
    margin: 0 65px;
    ul {
      display: inline-block;
      vertical-align: middle;
      padding-right: 15px;
      li {
        float: left;
        list-style: none;
        cursor: pointer;
        color: @txtColor1;
        display: block;
        height: 130px;
        line-height: 130px;
        padding: 5px 18px;
        a {
          font-size: 18px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          padding: 10px 0px;
          &:hover {
       
            color: rgba(255, 255, 255, 1);
          }
          &.a-cur {
            border-bottom: 3px solid #fff;
            color: rgba(255, 255, 255, 1);
          }
        }
        &.cur {
          position: relative;
          &::after {
            content: "";
            position: absolute;
            bottom: -1px;
            width: 100%;
            height: 2px;
            left: 0;
          }
        }
        &.cur,
        &:hover {
          color: @txtColor2;
        }
      }
    }
  }
  .lang {
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-top: 10px;
    i {
      display: inline-block;
      font-size: 20px;
      opacity: 0.5;
      margin-right: 5px;
    }
    span {
      color: #6d5353;
      display: inline-block;
    }
    .langlist {
      position: relative;
      top: 0px;
      a {
        color: #fff;
      }
      li {
        text-align: center;
      }
    }
  }
}
.ivu-input {
  font-size: 12px;
}
.white-color {
  color: #fff;
}
</style>
